import { render } from "./share-results.vue?vue&type=template&id=6c0e8583&scoped=true&ts=true"
import script from "./share-results.vue?vue&type=script&lang=ts"
export * from "./share-results.vue?vue&type=script&lang=ts"

import "./share-results.vue?vue&type=style&index=0&id=6c0e8583&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0e8583"]])

export default __exports__